import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsMetrics(companyId, regulationId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_METRICS,dtConfig[ModulesMap.REGULATIONS_METRICS].getRegulationsMetrics,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
			},
		},
	)
}
function getRegulationsMetricPreview(companyId, regulationId, metricId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_METRICS,dtConfig[ModulesMap.REGULATIONS_METRICS].getRegulationsMetricPreview,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				metricId,
			},
		},
	)
}
function getRegulationsMetricPopup(companyId, regulationId, metricId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_METRICS,dtConfig[ModulesMap.REGULATIONS_METRICS].getRegulationsMetricPopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				metricId,
			},
		},
	)
}

function createRegulationsMetric(companyId, regulationId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_METRICS,dtConfig[ModulesMap.REGULATIONS_METRICS].createRegulationsMetric, {
		urlParams: {
			companyId,
			regulationId,
		},
		...data,
	})
}

function getRegulationsMetric(companyId, regulationId, metricId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_METRICS,dtConfig[ModulesMap.REGULATIONS_METRICS].getRegulationsMetric, {
		urlParams: {
			companyId,
			regulationId,
			metricId,
		},
	})
}

function patchRegulationsMetric(companyId, regulationId, metricId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_METRICS,dtConfig[ModulesMap.REGULATIONS_METRICS].patchRegulationsMetric, {
		urlParams: {
			companyId,
			regulationId,
			metricId,
		},
		...data,
	})
}

function putRegulationsMetric(companyId, regulationId, metricId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_METRICS,dtConfig[ModulesMap.REGULATIONS_METRICS].putRegulationsMetric, {
		urlParams: {
			companyId,
			regulationId,
			metricId,
		},
		...data,
	})
}

function deleteRegulationsMetric(companyId, regulationId, metricId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_METRICS,dtConfig[ModulesMap.REGULATIONS_METRICS].deleteRegulationsMetric, {
		urlParams: {
			companyId,
			regulationId,
			metricId,
		},
	})
}

export default {
	getRegulationsMetrics,
	getRegulationsMetricPopup,
	getRegulationsMetricPreview,
	getRegulationsMetric,
	patchRegulationsMetric,
	putRegulationsMetric,
	createRegulationsMetric,
	deleteRegulationsMetric,
}
